import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SBreadcrumbs } from '@avalara/skylab-sdk/react';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { Link } from 'react-router-dom';
import { userIdentityLinkTo } from '../../utils/userIdentityRoutes';

const ALL_COMPANIES_GRANT = '*';

export const ViewCompanyPermissions = (props) => {
    let userId = props?.location?.state?.userId;
    let user = props?.users?.find(obj => obj.id === userId);

    useEffect(() => {
        if (!props.users || !userId) {
            props.history.push('/CompanyPermissions');
        }
    }, [props.users, props.history, userId]);

    let currentUser = `${user?.firstName} ${user?.lastName}`;
    const breadcrumbItems = [{
        label: LANGUAGES_CONTROLLER.format(props.languages, "CompanyPermissions_Title"),
        dataRef: "1",
        emitNavEvent: true
    },
    {
        label: currentUser,
        dataRef: "2"
    }];

    const handleNavClick = () => props.history.push('/CompanyPermissions');

    const companiesRows = () => {
        if (user?.companyGrants?.length > 0) {
            if (user.companyGrants.includes(ALL_COMPANIES_GRANT)) {
                return <span data-testid="comp-perm-company-value">{LANGUAGES_CONTROLLER.format(props.languages, "CompanyPermissions_AllCompanies")}<br /></span>
            }
            return user.companyGrants.map(companyId => {
                return (
                    <span key={companyId} data-testid="comp-perm-company-value">{props.companiesLookup[companyId]}<br /></span>
                );
            });
        }
        else {
            return <span data-testid="comp-perm-company-value">{LANGUAGES_CONTROLLER.format(props.languages, "CompanyPermissions_NoCompanies")}<br /></span>;
        }
    }

    const userDetails = () => {
        if (user) {
            return <table>
                <tr>
                    <th data-testid="comp-perm-firstname-column"><LanguageStringResolver className="float-left" string='ViewCompanyPermissions_FirstName' /></th>
                    <th data-testid="comp-perm-lastname-column"><LanguageStringResolver className="float-left" string='ViewCompanyPermissions_LastName' /></th>
                    <th data-testid="comp-perm-email-column"><LanguageStringResolver className="float-left" string='ViewCompanyPermissions_Email' /></th>
                </tr>
                <tr className="vertical-align-top">
                    <td>{user.firstName}</td>
                    <td>{user.lastName}</td>
                    <td>{user.id}</td>
                </tr>
            </table>
        }
    }

    const companies = companiesRows();
    const userTable = userDetails();
    const linkToUrl = userIdentityLinkTo('/EditCompanyPermissions', user?.id);

    return (
        <div className="content-area">
            {user &&
                <s-container data-testid="view-comp-perm-details">
                    <SBreadcrumbs data-testid="navigation-breadcrumbs" navItems={breadcrumbItems} navHandler={handleNavClick}></SBreadcrumbs>
                    <h1 className="mb0 mt0">{`${user.firstName} ${user.lastName}`}</h1>
                    <hr data-testid="horizontal-rule-one" />
                    <h3 className="mb0" data-testid="comp-perm-details-heading"><LanguageStringResolver string='ViewCompanyPermissions_UserDetails' /></h3>
                    {userTable}
                    <h3 className="mb0" data-testid="access-control-heading"><LanguageStringResolver string='ViewCompanyPermissions_AccessControl' /></h3>
                    {user.role}
                    <h3 className="mb0" data-testid="comp-perm-companies-heading"><LanguageStringResolver string='ViewCompanyPermissions_Companies' /></h3>
                    {companies}
                    <hr data-testid="horizontal-rule-two" />
                    <Link className="button primary float-left" to={linkToUrl} data-testid="comp-perm-edit-button">
                        <LanguageStringResolver string='EditCompanyPermissions_EditTitle' />
                    </Link>
                </s-container>
            }
        </div>
    );
};

export function mapStateToProps(state) {
    return {
        users: state.companyPermissions?.data,
        companiesLookup: state.companyPermissions?.companiesLookup
    };
}

export default connect(mapStateToProps)(ViewCompanyPermissions);
